export default __webpack_public_path__ + "static/media/dole-logo@2x.1c2b4a09.png";